import { render, staticRenderFns } from "./configObjectiveFile.vue?vue&type=template&id=67ee1cc0&scoped=true"
import script from "./configObjectiveFile.vue?vue&type=script&lang=js"
export * from "./configObjectiveFile.vue?vue&type=script&lang=js"
import style0 from "./configObjectiveFile.vue?vue&type=style&index=0&id=67ee1cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee1cc0",
  null
  
)

export default component.exports